import ColumnChartSkeleton from 'components/base/empty-states/skeletons/ColumnChartSkeleton';
import { useMemo } from 'react';
import styled from 'styled-components';

const StyledLoader = styled.div`
  width: 95%;
  height: 90%;
`;

const Loader = () => {
  const sizes = useMemo(() => {
    const currSizes = [];
    for (let size = 10; size < 95; size += 5) currSizes.push(size);
    return currSizes;
  }, []);

  return (
    <StyledLoader data-cy='progress-over-time-loader'>
      <ColumnChartSkeleton sizes={sizes} />
    </StyledLoader>
  );
};

export default Loader;
